import { useState } from 'react';

import { isCancelled, withoutCancelled } from './cancelled-workshops';
import type { WorkshopChip } from './workshopsCalendarTypes';

export interface CancelledFilter<T> {
  shown: T[];
  cancelledCount: number;
  showCancelled: boolean;
  toggle: () => void;
}

/** Hides cancelled workshops until the viewer asks for them. Resets on every
 *  visit by design — hidden is the default the page promises (BON-624). */
export function useCancelledFilter<T extends Pick<WorkshopChip, 'lifecycle'>>(
  workshops: T[],
): CancelledFilter<T> {
  const [showCancelled, setShowCancelled] = useState(false);
  return {
    shown: showCancelled ? workshops : withoutCancelled(workshops),
    cancelledCount: workshops.filter(isCancelled).length,
    showCancelled,
    toggle: () => setShowCancelled((v) => !v),
  };
}
